import { render, staticRenderFns } from "./constitute.vue?vue&type=template&id=e480e324&scoped=true&"
import script from "./constitute.vue?vue&type=script&lang=js&"
export * from "./constitute.vue?vue&type=script&lang=js&"
import style0 from "./constitute.vue?vue&type=style&index=0&id=e480e324&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e480e324",
  null
  
)

export default component.exports